import toPath from 'lodash.topath';
import { path } from 'ramda';
// getIn from https://github.com/formium/formik/blob/ae06d2b384d7395bf756d631327d2dfdb0dbd3dc/packages/formik/src/utils.ts#L69
export function getIn(obj, key) {
    var valuePath = typeof key === 'string' ? toPath(key) : key;
    var result = path(valuePath, obj);
    return result;
}
